import {useMutation} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface UseUserPinMutationOptions {
  /** URL path for the profile_pin endpoint (e.g. "/octocat/hello-world/profile_pin") */
  pinPath: string
}

/**
 * Hook to pin/unpin a repository on the viewer's personal profile.
 */
export function useUserPinMutation({pinPath}: UseUserPinMutationOptions) {
  return useMutation<void, Error, {isPinned: boolean}>({
    mutationFn: async ({isPinned}) => {
      const response = await verifiedFetchJSON(pinPath, {
        method: isPinned ? 'DELETE' : 'POST',
      })

      if (!response.ok) {
        let errorMessage = `Failed to ${isPinned ? 'unpin' : 'pin'} repository`

        if (response.status === 422) {
          try {
            const errorData = await response.text()
            errorMessage = errorData || errorMessage
            // eslint-disable-next-line unused-imports/no-unused-vars
          } catch (_: unknown) {
            // Ignore errors while parsing the error message.
          }
        }

        throw new Error(errorMessage)
      }
    },
  })
}
